import api from './api'

export const bundleService = {
  getAll: (params?: { search?: string; is_active?: boolean; page?: number; limit?: number }) =>
    api.get('/bundles', { params }),

  getById: (id: number) =>
    api.get(`/bundles/${id}`),

  create: (data: {
    bundle_name: string
    bundle_sku: string
    description?: string
    is_active?: boolean
    components: Array<{ product_id: number; quantity: number; is_optional?: boolean }>
  }) => api.post('/bundles', data),

  update: (id: number, data: {
    bundle_name?: string
    bundle_sku?: string
    description?: string
    is_active?: boolean
    components?: Array<{ product_id: number; quantity: number; is_optional?: boolean }>
  }) => api.put(`/bundles/${id}`, data),

  delete: (id: number) =>
    api.delete(`/bundles/${id}`),

  getInstances: (params?: { bundle_id?: number; status?: string; page?: number; limit?: number }) =>
    api.get('/bundles/instances', { params }),

  getInstanceById: (instanceId: number) =>
    api.get(`/bundles/instances/${instanceId}`),

  createInstance: (data: { bundle_id: number; serials: Array<{ component_id: number; serial_id: number }> }) =>
    api.post('/bundles/instances', data),
}
